module.exports = __webpack_public_path__ + "img/edit_pencil.48b417dc.svg";